import { CanActivateFn } from '@angular/router';
import { environment } from '../../../environments/environment';

export const landingRedirectGuard: CanActivateFn = () => {
  const browserWindow = globalThis.window;

  if (browserWindow && environment.landingUrl) {
    browserWindow.location.replace(environment.landingUrl);
  }

  return false;
};
